import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import cartModule from './cart.js'
import checkoutModule from './checkout.js'
import stateDataModule from './stateData.js'
import affiliateModule from './affiliate.js'
import homeschoolModule from './homeschool.js'
import dashboardModule from './dashboard.js'
import userModule from './user.js'
import schoolModule from "./school.js";
import adoptionModule from "./adoption";
import localStorageProxy from '@/common/localStorageProxy.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    },
    modules: {
        cart: cartModule,
        checkout: checkoutModule,
        stateData: stateDataModule,
        affiliate: affiliateModule,
        homeschool: homeschoolModule,
        dashboard: dashboardModule,
        school: schoolModule,
        user: userModule,
        adoption: adoptionModule,
    },
    plugins: [new VuexPersistence({
    	storage: localStorageProxy
    }).plugin],

})
